import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('ManrefType?page=' + page, {params});
    }, 
    show(id) {
        return Service().get('ManrefType/show/'+id);
    },    
    create(params) {
        return Service().post('ManrefType/create', params);
    },
    update(id, params) {
        return Service().post('ManrefType/update/'+id, params);
    },
    delete(id) {
        return Service().post('ManrefType/delete/'+id);
    }
}